import React from 'react';
import { getCategoryStyles } from '../../lib/categoryStyles';

interface FilterChipsProps {
  categories: string[];
  selectedCategories: string[];
  onToggleCategory: (cat: string) => void;
  onClearCategories: () => void;
  genders: string[];
  selectedGender: string | null;
  onSelectGender: (gen: string | null) => void;
  primaryColor: string;
}

export function FilterChips({
  categories,
  selectedCategories,
  onToggleCategory,
  onClearCategories,
  genders,
  selectedGender,
  onSelectGender,
  primaryColor
}: FilterChipsProps) {
  const reversedCategories = [...categories].reverse();

  return (
    <div className="relative w-full py-4 mb-2 flex flex-col items-center">
      {/* Full Bleed Background */}
      <div className="absolute inset-y-0 w-[200vw] left-1/2 -translate-x-1/2 bg-black/20 backdrop-blur-md border-y border-white/5 pointer-events-none" />
      
      {/* Wrapper to force same horizontal extension on both rows */}
      <div className="w-full max-w-md mx-auto flex flex-col gap-4 items-center relative z-10 px-2 sm:px-0">
        
        {/* Gender Filter */}
        <div className="flex flex-col gap-2 items-center w-full">
          <div className="flex w-full gap-1.5">
            <button
              key="todos"
              onClick={() => onSelectGender(null)}
              className={`flex-1 text-[9px] sm:text-[10px] font-bold uppercase tracking-wider py-1.5 rounded-lg border transition-all active:scale-95 cursor-pointer select-none ${
                selectedGender === null
                  ? 'bg-transparent text-white border-white opacity-100 shadow-sm'
                  : 'bg-white/5 text-zinc-400 border-white/5 hover:bg-white/10 hover:text-white'
              }`}
            >
              Todos
            </button>
            {genders.map(gender => {
              const isActive = selectedGender === gender;
              return (
                <button
                  key={gender}
                  onClick={() => onSelectGender(isActive ? null : gender)}
                  className={`flex-1 text-[9px] sm:text-[10px] font-bold uppercase tracking-wider py-1.5 rounded-lg border transition-all active:scale-95 cursor-pointer select-none ${
                    isActive
                      ? 'bg-transparent text-white border-white opacity-100 shadow-sm'
                      : 'bg-white/5 text-zinc-400 border-white/5 hover:bg-white/10 hover:text-white'
                  }`}
                >
                  {gender}
                </button>
              );
            })}
          </div>
        </div>

        {/* Category Filter */}
        <div className="flex flex-col gap-2 items-center w-full">
          <div className="flex w-full gap-0.5 sm:gap-1.5 justify-between">
            <button
              key="todas"
              onClick={onClearCategories}
              className={`flex-1 text-[8px] sm:text-[10px] font-bold uppercase tracking-wider px-0 py-1 sm:px-3 sm:py-1.5 rounded-md sm:rounded-lg border transition-all active:scale-95 cursor-pointer select-none text-center ${
                selectedCategories.length === 0
                  ? 'bg-transparent text-white border-white opacity-100 shadow-sm'
                  : 'bg-white/5 text-zinc-400 border-white/5 hover:bg-white/10 hover:text-white'
              }`}
            >
              Todas
            </button>
            {reversedCategories.map(cat => {
              const isActive = selectedCategories.includes(cat);
              return (
                <button
                  key={cat}
                  onClick={() => onToggleCategory(cat)}
                  className={`flex-1 text-[8px] sm:text-[10px] font-bold uppercase tracking-wider px-0 py-1 sm:px-3 sm:py-1.5 rounded-md sm:rounded-lg border transition-all active:scale-95 cursor-pointer select-none text-center ${
                    isActive
                      ? 'bg-transparent text-white border-white opacity-100 shadow-sm'
                      : 'bg-white/5 text-zinc-400 border-white/5 hover:bg-white/10 hover:text-white'
                  }`}
                >
                  {cat}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
